import * as consultationComponents from '../constants/consultationComponents';

import haircareBackgroundDesktop from 'assets/images/consultation/transitionScreens/d-intro.jpg';
import haircareBackgroundMobile from 'assets/images/consultation/transitionScreens/m-intro.jpg';
import haircareBackgroundTablet from 'assets/images/consultation/transitionScreens/t-intro.jpg';

const consultationHairWelcome = {
  name: 'welcome',
  route: `/consultation/haircare`,
  Component: consultationComponents.Welcome,
  title: <>We’re excited to get started on your consultation.</>,
  subtitle:
    'We’ll ask a series of questions to understand your unique hair needs and goals, lifestyle, and environment so we can formulate your custom haircare products and supplements and provide your recommended routine.',
  cta: 'Begin',
  image: {
    mobile: haircareBackgroundMobile,
    tablet: haircareBackgroundTablet,
    desktop: haircareBackgroundDesktop,
  },
  isEnabled: ({ showSkincare }) => !showSkincare,
  shouldBeIncluded: ({ isAuthenticated }) => !isAuthenticated,
  public: true,
  skipSave: true,
};

export default consultationHairWelcome;
